import { makeStyles, createTheme } from "@material-ui/core/styles";
export const useStyles = makeStyles(
  theme => ({
    root: {
      display: "flex",
      flexDirection: "column",
      "& .MuiTextField-root": {
        width: 200,
        backgroundColor: "white",
        borderRadius: "3px",
      },
      "& .MuiInput-input": {
        paddingLeft: "5px",
      },
    },
    flexRow: {
      display: "flex",
      flexDirection: "row",
    },
    reverseColumn: {
      display: "flex",
      flexDirection: "column-reverse",
    },
    formControl: {
      margin: theme.spacing(1),
      // minWidth: 120,
    },
    leftMargin: {
      marginLeft: theme.spacing(1),
    },
    containerSpacer: {
      "& > *": {
        margin: theme.spacing(1),
        width: "25ch",
      },
    },
    content: {
      flexGrow: 1,
      // paddingTop: theme.spacing(1),
      // paddingBottom: theme.spacing(1),
    },
    hover: {
      "&:hover": {
        color: "#d9833b",
        cursor: "pointer",
      },
    },
    whiteHover: {
      color: "white",
      "&:hover": {
        color: "#d9833b",
      },
    },
    historyButton: {
      color: "black",
      backgroundColor: "yellow",
      fontWeight: "bold",
      height: "8vmin",
      width: "8vmin",
      // margin: "10px 1vmax",
      border: "2px solid black",
    },
    addButton: {
      color: "black",
      backgroundColor: "green",
      fontWeight: "bold",
      height: "8vmin",
      width: "8vmin",
      // margin: "10px 1vmax",
      border: "2px solid black",
    },
    deleteButton: {
      color: "black",
      backgroundColor: "red",
      fontWeight: "bold",
      height: "8vmin",
      width: "8vmin",
      // margin: "10px 1vmax",
      border: "2px solid black",
    },
    mapButton: {
      color: "black",
      backgroundColor: "lightblue",
      fontWeight: "bold",
      height: "8vmin",
      width: "8vmin",
      margin: "10px 1vmax",
      border: "2px solid black",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    ticketModal: {
      maxHeight: "95vh",
      overflow: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalInput: {
      margin: "10px 10px",
    },
    paper: {
      position: "absolute",
      width: "90vw",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid grey",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 2, 3),
      maxHeight: "75vh",
      overflowY: "auto",
    },
    licenseScanModal: {
      maxHeight: "75vh",
      display: "flex",
      flexDirection: "column",
      padding: 0,
      width: "100%",
      overflowY: "auto",
    },
    dmvModals: {
      position: "absolute",
      width: "90vw",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      maxHeight: "90vh",
      display: "flex",
      flexDirection: "column",
    },
    modalContent: {
      display: "flex",
      flexDirection: "column",
      alignContent: "space-between",
      overflowY: "auto",
    },
    tablePaper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    linkButton: {
      backgroundColor: "transparent",
      color: "#6096d1",
      fontWeight: "bold",
      fontSize: "1rem",
      border: "none",
      cursor: "pointer",
      textDecoration: "underline",
      display: "inline",
      margin: "0",
      padding: "0",
      "&:hover": {
        textDecoration: "none",
      },
      "&:focus": {
        textDecoration: "none",
      },
    },
    linkButtonDisabled: {
      backgroundColor: "transparent",
      color: "#7d7d7d",
      fontWeight: "bold",
      fontSize: "1rem",
      border: "none",
      display: "inline",
      margin: "0",
      padding: "0",
      "&:hover": {
        textDecoration: "none",
      },
      "&:focus": {
        textDecoration: "none",
      },
    },
    underline: {
      borderBottom: "none",
      "&::after": {
        borderBottom: "1px solid #d9833b",
      },
      "&::before": {
        borderBottom: "1px solid white",
      },
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    whiteChip: {
      margin: 2,
      backgroundColor: "rgba(96, 151, 209, 1)",
      color: "white",
      fontWeight: "bold",
      fontSize: "1.1rem",
    },
    textInput: {
      margin: theme.spacing(1),
    },
    fabButton: {
      color: "white",
      backgroundColor: "#050b7d",
      fontWeight: "bolder",
      fontSize: "1rem",
      margin: "0 0.5rem",
      minWidth: "2vw",
      minHeight: "2vw",
      maxWidth: "4vw",
      maxHeight: "4vw",
    },
    headerAddButton: {
      color: "white",
      backgroundColor: "#050b7d",
      fontWeight: "bolder",
      fontSize: "1rem",
      margin: "0 0.5rem",
      minWidth: "2vw",
      minHeight: "2vw",
      maxWidth: "2vw",
      maxHeight: "2vw",
    },
    select: {
      "& .MuiSelect-icon": {
        color: "white",
      },
      "&.Mui-focused .MuiSelect-icon": {
        color: "#d9833b",
      },
      "&:hover .MuiSelect-icon": {
        color: "#d9833b",
      },
      "&.MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: "2px solid #d9833b !important",
      },
      "&.MuiInput-underline:hover:not(.Mui-disabled):after": {
        borderBottom: "2px solid #d9833b !important",
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    whiteLabel: {
      color: "white",
      "&.MuiFormLabel-root.Mui-focused": {
        color: "#d9833b",
      },
    },
    label: {},
    redLabel: {
      color: "red !important",
    },
    tabsDiv: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
    tableContainer: {
      height: "100%",
      width: "100%",
    },
    table: {
      minWidth: 650,
      borderCollapse: "collapse",
    },
    tableCellBorder: {
      borderRight: "2px solid #e3e2e2",
      textAlign: "center",
      padding: 0,
    },
    insideTableCell: {
      maxWidth: "fit-content",
      marginLeft: "1vw",
      marginRight: "1vw",
    },
    spacingToRight: {
      marginRight: "25px",
    },
    wideForm: {
      margin: theme.spacing(1),
      minWidth: 120,
      width: "75vw",
      whiteSpace: "nowrap",
      display: "flex",
      // alignItems: 'center',
      justifyContent: "center",
    },
    offline: {
      color: "red",
    },
    forcedOnline: {
      color: "orange",
    },
    navBarButtons: {
      borderRadius: "10px",
      height: "auto",
      backgroundColor: "#6096d1",
      color: "white",
      fontSize: "large",
      minWidth: "5vw",
    },
    buttonHover: {
      "&:hover": {
        backgroundColor: "#d9833b",
      },
    },
    tableH3Container: {
      textAlign: "center",
      backgroundColor: "#fae8ad",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
      padding: "10px 12px",
    },
    tableH3ContainerLight: {
      textAlign: "center",
      backgroundColor: "#fae8ad",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
      padding: "10px 12px",
    },
    tableH3ContainerDark: {
      textAlign: "center",
      backgroundColor: "#616161",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
      padding: "10px 12px",
    },
    logsContainerDark: {
      backgroundColor: "#616161",
      padding: "0 10px",
    },
    logsContainerLight: {
      backgroundColor: "#fae8ad",
      padding: "0 10px",
    },
    queryReturnContainer: {
      backgroundColor: "#eee",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
      padding: "10px 12px",
    },
    tableH3Title: {
      display: "in-line block",
      color: "#303e4f",
      margin: "0px",
      fontFamily: "sans-serif",
      fontWeight: "bold",
      fontSize: "1rem",
    },
    tableH3TitleLight: {
      display: "in-line block",
      color: "#303e4f",
      margin: "0px",
      fontFamily: "sans-serif",
      fontWeight: "bold",
      fontSize: "1rem",
    },
    tableH3TitleDark: {
      display: "in-line block",
      color: "white",
      margin: "0px",
      fontFamily: "sans-serif",
      fontWeight: "bold",
      fontSize: "1rem",
    },
    tableHeader: {
      background: "#7a8697",
      height: "fit-content",
      padding: 0,
      textAlign: "center",
      color: "white",
      fontSize: "1rem",
    },
    greyDiv: {
      backgroundColor: "rgba(236, 236, 236)",
    },
    darkDiv: {
      backgroundColor: "black",
    },
    responsiveText: {
      fontSize: "1.15rem",
      fontWeight: "bold",
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.75rem",
      },
    },
    menuButton: {
      margin: "0 1vw",
      width: "10vw",
      backgroundColor: "#5097d6",
      color: "white",
    },
    appBar: {
      // zIndex: theme.zIndex.drawer + 1,
      zIndex: 3,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: "#303e4f !important",
      width: "100%",
    },
    matchMargin: {
      margin: "17px",
    },
    flexMatchSize: {
      flexGrow: 1,
    },
    singleDropDownPaddingAdjustment: {
      padding: "6px 0 3px",
    },
    smallMatchMargin: {
      margin: theme.spacing(1),
      justifyContent: "flex-end",
    },
    textfieldMarginAndFlexEnd: {
      margin: theme.spacing(1),
      justifyContent: "flex-end",
    },
    leftMarginMatch: {
      marginLeft: theme.spacing(1),
      justifyContent: "flex-end",
    },
    warning: {
      fontWeight: "bold",
      "& .MuiInputBase-input": {
        color: "red",
      },
    },
    disabled: {
      "&:hover": {
        cursor: "not-allowed",
      },
    },
    bigFont: {
      fontSize: "30px",
      border: "3px solid red",
    },
    dropdown: {
      margin: theme.spacing(1),
      minWidth: 120,
      width: "25%",
    },
    fitHeight: {
      height: "fit-content",
    },
    tabRoot: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    tabHover: {
      color: "black",
      "&:hover": {
        color: "#d9833b !important",
      },
    },
    expansionPanelTypography: {
      fontWeight: "bold",
      fontSize: "1rem",
      margin: 0,
    },
    pngButton: {
      maxWidth: "30px",
      maxHeight: "30px",
      minWidth: "2vw",
      minHeight: "2vw",
      margin: "8px",
      "&:hover": {
        opacity: 0.6,
        cursor: "pointer",
      },
    },
    disabledPngButton: {
      maxWidth: "30px",
      maxHeight: "30px",
      minWidth: "2vw",
      minHeight: "2vw",
      margin: "8px",
      "&:hover": {
        cursor: "not-allowed",
      },
    },
    stack: {
      display: "grid",
      alignItems: "center",
      "& *": {
        gridRow: 1,
        gridColumn: 1,
      },
    },
    notificationBadge: {
      color: "red",
      position: "absolute",
      top: "1.6vw",
      right: "1.2vw",
      fontSize: "0.8vw",
    },
    textAreaLight: {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      width: "100%",
    },
    textAreaDark: {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      width: "100%",
      backgroundColor: "black",
      color: "white",
    },
    vcvc_required: {
      border: "2px solid red",
    },
    fixedWidth: {
      width: "200px",
      maxWidth: "200px",
    },
    warning_recommended: {
      border: "2px solid #0080ff",
    },
    vcvcfixedWidth: {
      width: "100px",
      maxWidth: "100px",
    },
  }),
  { index: 999 },
);

export const darkTheme = createTheme(
  {
    palette: {
      type: "dark",
      background: {
        paper: "black",
      },
    },
    overrides: {
      MuiCollapse: {
        root: {
          backgroundColor: "black",
        },
      },
      MuiTabs: {
        scroller: {
          color: "#000000",
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          "&$checked": {
            color: "red",
          },
        },
      },
      MuiFormControlLabel: {
        label: {
          color: "#ffffffb3;",
        },
      },
    },
  },
  { index: 1 },
);

export const lightTheme = createTheme({
  palette: {
    type: "light",
  },
  overrides: {
    MuiCollapse: {
      root: {
        //This was only affecting the incident detail frame
        // backgroundColor: '#d8e8f9'
      },
    },
  },
});
export const emptyTheme = createTheme({
  palette: {},
});
